<template>
  <div>
    <Head title="Profil" />
    <h1 class="mb-8 text-3xl font-bold">Profil</h1>

    <div class="mb-8">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div class="bg-gray-50 rounded-lg py-2 px-3 border border-gray-200">
          <p class="text-xs font-semibold text-gray-600 uppercase">Nume</p>
          <p class="text-lg text-gray-800">
            {{ admin.first_name }} {{ admin.last_name }}
          </p>
        </div>
        <div class="bg-gray-50 rounded-lg py-2 px-3 border border-gray-200">
          <p class="text-xs font-semibold text-gray-600 uppercase">Email</p>
          <p class="text-lg text-gray-800">
            {{ admin.email }}
          </p>
        </div>
      </div>
    </div>

    <h2 class="mb-4 text-2xl font-bold">Schimba parola</h2>
    <div class="max-w-3xl overflow-hidden rounded-sm bg-white shadow-sm">
      <form class="p-8" @submit.prevent="submit">
        <PasswordInput
          v-model="form.user.current_password"
          :error="form.errors.current_password"
          label="Parola curenta"
          class="w-full pb-4 md:w-1/2"
        />
        <PasswordInput
          v-model="form.user.password"
          :error="form.errors.password"
          class="w-full pb-4 md:w-1/2"
          label="Parola noua"
        />
        <PasswordInput
          v-model="form.user.password_confirmation"
          :error="form.errors.password_confirmation"
          class="w-full pb-4 md:w-1/2"
          label="Repeta parola noua"
        />
        <div class="flex items-center mt-4">
          <loading-button
            :loading="form.processing"
            class="btn-teal"
            type="submit"
          >
            Modifica parola
          </loading-button>
        </div>
      </form>
      <transition-group
        name="p-message"
        tag="div"
        class="flex flex-col px-8 pb-4"
      >
        <Message
          v-for="(msg, index) of messages"
          :key="index"
          severity="success"
          :life="3000"
          icon="pi pi-check"
          closable
        >
          {{ msg }}
        </Message>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3';
import Layout from '@/Layouts/Main.vue';
import LoadingButton from '@/Shared/LoadingButton.vue';
import PasswordInput from '@/Shared/PasswordInput.vue';
import Message from 'primevue/message';
import axios from 'axios';

export default {
  components: {
    Head,
    LoadingButton,
    PasswordInput,
    Message,
  },
  layout: Layout,
  props: {
    admin: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: this.$inertia.form({
        user: {
          password: '',
          password_confirmation: '',
          current_password: '',
        },
      }),
      messages: [],
    };
  },
  methods: {
    submit() {
      let self = this;
      axios
        .patch(this.$routes.update_password_user(this.admin.id), {
          format: 'json',
          ...this.form,
        })
        .then(function () {
          self.messages.push('Parola a fost modificata cu success');
          self.form.errors = {};
          self.form.user = {
            password: '',
            password_confirmation: '',
            current_password: '',
          };
        })
        .catch(function (error) {
          self.form.errors = error.response.data.errors;
        });
    },
  },
};
</script>
